import { useFeatureFlagsQuery } from '@/generated/graphql';

/** Defaults to true (paywalls on) until flags load. */
export function useMonetizationEnabled() {
  const { data, loading } = useFeatureFlagsQuery();
  return {
    monetizationEnabled: data?.featureFlags.monetizationEnabled ?? true,
    loading,
  };
}
